export default __webpack_public_path__ + "2600581ec3c3134aa3e75e6c7ddff37f.svg";